var map = {
	"./0.png": "1d70",
	"./1.png": "7bd0",
	"./2.png": "6d5a",
	"./3.png": "f140",
	"./4.png": "3bc5",
	"./5.png": "136e",
	"./6.png": "c8ad",
	"./7.png": "da9e",
	"./8.png": "0bd4",
	"./9.png": "c527",
	"./n.png": "7de9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4336";